import { render, staticRenderFns } from "./NetBilling.vue?vue&type=template&id=39c68a2f&"
import script from "./NetBilling.vue?vue&type=script&lang=ts&"
export * from "./NetBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports